/**
 * Formats a stored phone value for display: ensures a leading + when digits are present.
 * Does not alter form inputs — use only when rendering phone numbers as text.
 */
export function formatPhoneDisplay(phone) {
  if (phone == null || phone === undefined) return '—';
  const s = String(phone).trim();
  if (s === '' || s === '—' || s === '–' || s === '-') return '—';
  if (s.startsWith('+')) return s;
  return `+${s}`;
}
